import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import errorSlice from '../components/error/errorSlice';
import { aufwandApi } from '../features/aufwand/api/aufwandApi';
import { authApi } from '../features/auth/api/authApi';
import authSlice from '../features/auth/api/authSlice';
import { datenschutzApi } from '../features/datenschutz/datenschutzApi';
import { kundeApi } from '../features/kunde/api/kundeApi';
import { mitarbeiterApi } from '../features/mitarbeiter/api/mitarbeiterApi';
import { projektApi } from '../features/projekt/api/projektApi';

export const store = configureStore({
  reducer: {
    [mitarbeiterApi.reducerPath]: mitarbeiterApi.reducer,
    [kundeApi.reducerPath]: kundeApi.reducer,
    [projektApi.reducerPath]: projektApi.reducer,
    [aufwandApi.reducerPath]: aufwandApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    auth: authSlice,
    errors: errorSlice,
    [datenschutzApi.reducerPath]: datenschutzApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(mitarbeiterApi.middleware)
      .concat(projektApi.middleware)
      .concat(aufwandApi.middleware)
      .concat(kundeApi.middleware)
      .concat(authApi.middleware)
      .concat(datenschutzApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
